import { usePopoverValue } from '@components/navigation/PopoverMenu/PopoverMenu';
import { ListItemText, MenuItem } from '@mui/material';
import { GanttStripDto } from '@types';
import React, { memo } from 'react';
import { FormattedMessage } from 'react-intl';

export const StripMenuItemAssociationDayOnly = memo(function StripMenuItemAssociationDayOnly({
    slot,
    onClick,
}: {
    slot: GanttStripDto;
    onClick?: () => void;
}) {
    const close = usePopoverValue('close');

    const hideMenuItem = slot.sibt && slot.sobt;

    if (hideMenuItem) {
        return null;
    }

    return (
        <MenuItem
            onClick={() => {
                onClick?.();
                close();
            }}
        >
            <ListItemText>
                <FormattedMessage id="strip.actions.slotAssociationDayOnly" />
            </ListItemText>
        </MenuItem>
    );
});
